// extracted by mini-css-extract-plugin
export var chevronIcon = "_9u-2";
export var teamName = "_9u-1";
export var teamSwitcherButton = "_9u-0";